
import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getOperationEntitiesByGroupForDropDown,
    GetHarvestingJobEmployee,
    getCollectionPointsByOperationentityGroupID,
    getGroups,
    GetEmployeeTypesData,
    getDivisions,
    getEstatesByGroupID,
    getAvailableHaverstingJobTypeByCollectionPointIDEmployeeTypeID,
    UpdateEmployeeHaverstingJobType
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetHarvestingJobEmployee(operationEntityID, collectionPointID, employeeTypeID, employeeCode, fromDate, toDate) {
    var newModel = {
        operationEntityID: parseInt(operationEntityID),
        collectionPointID: parseInt(collectionPointID),
        employeeTypeID: parseInt(employeeTypeID),
        employeeCode: employeeCode,
        fromDate: fromDate === "" ? null : fromDate,
        toDate: toDate === "" ? null : toDate,
    }
    const response = await CommonPost('/api/Employee/GetHarvestingJobEmployee', null, newModel);
    return response.data;
}

async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function GetEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function getDivisions(estateID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateId=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return array;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]

    }
    return array;
}

async function getAvailableHaverstingJobTypeByCollectionPointIDEmployeeTypeID(collectionPointID, employeeTypeID) {
    const response = await CommonGet('/api/HaverstingJobType/GetHaverstingJobTypeByCollectionPointIDEmployeeTypeID', 'collectionPointID=' + collectionPointID + '&employeeTypeID=' + employeeTypeID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["haverstingJobTypeID"]] = item[1]["haverstingJobTypeName"]

    }
    return array;
}

async function UpdateEmployeeHaverstingJobType(saveData) {
    const response = await CommonPost('/api/Employee/UpdateEmployeeHaverstingJobType', null, saveData);
    return response;
}